import { useContext, useEffect } from 'react'
import { toast } from 'react-toastify'
import AuthContext from './AuthContext'

export const Logout = () => {
    const auth = useContext(AuthContext)

    useEffect(() => {
        auth.state.axiosInstance?.post('/api/auth/logout')
            .then(res => {

                toast.success("Disconnessione avvenuta correttamente. Arrivederci !")
            })
            .catch(error => {
                toast.error('🛑 Errore durante la disconnessione!');
                console.log(error);
            })
            .finally(() => {
                auth.dispatch({ type: 'LOGOUT' })
            }
            )

    }, [auth])

    return (
        <div>
        </div>
    )
}

export default Logout